import config from '@/config'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000
  })
}

const KingkitchenApi = {
  postKingkitchenImport: (request) => {
    const { data } = request
    return instance().post('/api/kingkitchen/cms/branches', data)
  },
  getKingkitchenBranch: (request) => {
    const { config } = request
    return instance().get('/api/kingkitchen/cms/branch', config)
  },
  putEditEmployee: (request) => {
    const { data } = request
    return instance().put('/api/kingkitchen/cms/employee', data)
  },
  deleteBranch: (request) => {
    const { branch_id } = request
    return instance().delete('/api/kingkitchen/cms/branch', { data: { branch_id } })
  }
}

export default KingkitchenApi



// WEBPACK FOOTER //
// ./src/api/kingkitchen.js